import { BooleanField } from '@scale/shared/types/params/textcollection';
import { Checkbox, Typography, Tooltip, Icon } from '@scale/scaleui';
import { Controller } from 'react-hook-form';

interface BooleanFieldSectionProps {
  field: BooleanField;
  disabled?: boolean;
}

export default function BooleanFieldSection(props: BooleanFieldSectionProps) {
  return (
    <>
      <div>
        <div className="flex gap-4">
          <div className="flex flex-row">
            <Typography.Paragraph1>{props.field.title}</Typography.Paragraph1>
            {props.field.hint && (
              <Tooltip
                asChild
                side="top"
                text={props.field.hint}
                target={
                  <div>
                    <Icon icon={['far', 'info-circle']} size="sm" />
                  </div>
                }
              />
            )}
          </div>
          <Controller
            name={props.field.field_id}
            defaultValue={false}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                onChange={e => {
                  field.onChange(e);
                }}
                disabled={props.disabled}
              />
            )}
          />
        </div>
        <Typography.Paragraph3>{props.field.description}</Typography.Paragraph3>
      </div>
    </>
  );
}
